<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
				<el-form-item :label="$t('course_index.cate')" prop="cate" data-name="分类">
	            	<el-select v-model="filterForm.cate_node_id" class="w100" :placeholder="$t('index.select')">
	                	<el-option v-for="(item,index) in camp_list" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.id"></el-option>
	            	</el-select>
	    		</el-form-item>
				<el-form-item :label="$t('course_index.date')" prop="date" data-name="日期">
					<el-date-picker v-model="filterForm.date" clearable value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
				</el-form-item>
				<el-form-item :label="$t('course_index.session')" prop="session" data-name="学期">
					<el-select v-model="filterForm.session" clearable class="w100" :placeholder="$t('index.pleaseInput')">
						<el-option v-for="(item,index) in SESSION_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.teacher')" prop="teacher_id" data-name="老师">
					<el-select v-model="filterForm.teacher_id" clearable class="w100" :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in teacher" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.teacher_id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.title')" prop="keyword" data-name="名称">
					<el-input v-model="filterForm.keyword" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item label="ID" prop="ID" data-name="id">
					<el-input v-model="filterForm.id" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="handleCurrentChange(1)">{{$t('index.search')}}</el-button>
					<el-button type="" size="mini" @click="reset(1)">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
			<div class="fr">
				<el-button type="primary" size="mini" @click="camp_export">{{$t('index.export')}}</el-button>
			</div>
		</div>
		<el-descriptions class="margin-top" :column="3" size="small" border>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.max_people')}}</template>{{data_data.all_max_student_num}}</el-descriptions-item>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.student_num')}}</template>{{data_data.all_student_num}}</el-descriptions-item>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.baokelv')}}</template>{{data_data.all_baokelv}}</el-descriptions-item>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.coupon_price')}}</template>{{data_data.all_coupon_price}}</el-descriptions-item>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.score')}}</template>{{data_data.all_score}}</el-descriptions-item>
		    <el-descriptions-item><template slot="label">{{$t('statistic_course.pay_price')}}</template>{{data_data.all_pay_price}}</el-descriptions-item>
		</el-descriptions>
		<p><br></p>
		<!-- <el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
			<el-form-item :label="$t('statistic_course.max_people')" data-name="报名上限"><p class="data_data">{{data_data.all_max_student_num}}</p></el-form-item>
			<el-form-item :label="$t('statistic_course.student_num')" data-name="报名人数"><p class="data_data">{{data_data.all_student_num}}</p></el-form-item>
			<el-form-item :label="$t('statistic_course.baokelv')" data-name="报课率"><p class="data_data">{{data_data.all_baokelv}}</p></el-form-item>
			<el-form-item :label="$t('statistic_course.coupon_price')" data-name="优惠金额"><p class="data_data">{{data_data.all_coupon_price}}</p></el-form-item>
			<el-form-item :label="$t('statistic_course.score')" data-name="使用积分"><p class="data_data">{{data_data.all_score}}</p></el-form-item>
			<el-form-item :label="$t('statistic_course.pay_price')" data-name="课程收入"><p class="data_data">{{data_data.all_pay_price}}</p></el-form-item>
		</el-form> -->
		<el-table :data="list" border size="mini" :default-sort = "{prop: 'id', order: 'descending'}" :show-summary="true" :summary-method="summary_method_f" row-key="id" :default-expand-all="false" :tree-props="{children: 'children'}">
			<el-table-column prop="id" align="left" sortable label="ID" data-name="id" width="95"></el-table-column>
			<el-table-column align="center" :label="$t('course_index.title')+'/'+$t('course_index.theme')" data-name="名称" width="400">
				<template slot-scope="{row}">
					<p v-if="row.title">{{lang=='cn'?row.title_cn:row.title}}</p>
					<p v-else>{{lang=='cn'?row.theme_cn:row.theme}}</p>
				</template>
			</el-table-column>
			<el-table-column :prop="lang=='cn'?'teacher_name_cn':'teacher_name'" align="center" :label="$t('course_index.teacher')" data-name="老师"></el-table-column>
			<el-table-column prop="session" align="center" :label="$t('course_index.session')" data-name="学期">
				<template slot-scope="scope">{{scope.row.term | session_ff(this_)}}</template>
			</el-table-column>
			<el-table-column prop="price" align="center" :label="$t('course_index.half_price')+'/'+$t('course_index.full_price')" data-name="单价">
				<template slot-scope="scope">{{scope.row.half_price}} / {{scope.row.price}}</template>
			</el-table-column>
			<el-table-column prop="this_max_student" sortable align="center" :label="$t('statistic_course.max_people')" data-name="报名上限"></el-table-column>
			<el-table-column prop="student_num" sortable align="center" :label="$t('statistic_course.student_num')" data-name="报名人数"></el-table-column>
			<el-table-column prop="baokelv" sortable align="center" :label="$t('statistic_course.baokelv')" data-name="报课率"></el-table-column>
			<el-table-column prop="this_coupon_price" sortable align="center" :label="$t('statistic_course.coupon_price')" data-name="优惠金额"></el-table-column>
			<el-table-column prop="this_score" sortable align="center" :label="$t('statistic_course.score')" data-name="使用积分"></el-table-column>
			<el-table-column prop="this_pay_price" sortable align="center" :label="$t('statistic_course.pay_price')" data-name="课程收入"></el-table-column>
		</el-table>
		<!-- <div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
		</div> -->
	</div>
</template>
<script>
export default {
	computed: {
		props_(){
			return{
				checkStrictly: true,
				value: 'id',
				label: this.lang=='cn'?'name_cn':'name',
			}
		},
	},
	data() {
		return {
			API_URL:process.env.API_URL,
			this_:this,
			list: [],
			filterForm: {
				keyword:'',
				teacher_id:'',
				session:'',
				id:'',
				cate_node_id:'',
				date:[],
			},
			camp_list:[],
			SESSION_ARR: [],
			teacher:[],
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			data_data:{},
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: 'SESSION_ARR',
			}
			this_.$post(url, datas).then((res) => {
				this_.SESSION_ARR = res.SESSION_ARR;
			})
			var url = "courseScreen";
			this_.$post(url, {}).then((res) => {
				this_.camp_list = res.camp_list; //分类
				this_.teacher = res.teacher; //老师
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "courseCampList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
				teacher_id: this_.filterForm.teacher_id,
				session: this_.filterForm.session,
				keyword: this_.filterForm.keyword,
				id: this_.filterForm.id,
				cate_node_id: this_.filterForm.cate_node_id,
			};
			if (this_.filterForm.date&&this_.filterForm.date.length>0) {
				datas['start_search_time']=Math.round(this_.filterForm.date[0]/1000);
				datas['end_search_time']=Math.round(this_.filterForm.date[1]/1000);
			}
			this_.$post(url, datas).then((res) => {
				var list=res.list;
				list.forEach(function(e,i) {
					e['children']=e.theme;
				});
				this_.list = list;
				this_.data_data=res;
				this_.pages.count = res.sum;
			})
		},
		// 重置
		reset(){
			this.filterForm={
				keyword:'',
				teacher_id:'',
				session:'',
				id:'',
				cate_node_id:'',
				date:[],
			}
			this.handleCurrentChange(1);
		},
		summary_method_f(res){
			var this_=this;
	        const { columns, data } = res;
	        const sums = [];
	        columns.forEach(function(e, i) {
	        	const values = data.map(item => Number(item[e.property]));
	        	var property={
	        		'this_max_student':this_.data_data.all_max_student_num,
	        		'student_num':this_.data_data.all_student_num,
	        		'baokelv':this_.data_data.all_baokelv,
	        		'this_coupon_price':this_.data_data.all_coupon_price,
	        		'this_score':this_.data_data.all_score,
	        		'this_pay_price':this_.data_data.all_pay_price,
	        	};
	        	if (i==0) {
	        		sums[i]=this_.lang=='cn'?'合计':'total';
	        	}else if(property[e.property]){
	        		sums[i]=property[e.property]
	        	}else{
	        		sums[i]='N/A';
	        	}
	        });
	        return sums
		},
		camp_export(){
			var TokenId = sessionStorage.getItem('TokenId');
			var lang  = localStorage.getItem('lang')!='cn'?'us':'cn';
			var url =  process.env.API_ROOT+'courseCampExport?TokenId='+TokenId+'&language='+lang;
			var filterForm=this.filterForm;
			if (filterForm.teacher_id) {
				url+='&teacher_id='+filterForm.teacher_id;
			}
			if (filterForm.session) {
				url+='&session='+filterForm.session;
			}
			if (filterForm.keyword) {
				url+='&keyword='+filterForm.keyword;
			}
			if (filterForm.id) {
				url+='&id='+filterForm.id;
			}
			if (filterForm.date&&filterForm.date.length) {
				url+='&start_search_time='+Math.round(filterForm.date[0]/1000)+'&end_search_time='+Math.round(filterForm.date[1]/1000);
			}
			if (filterForm.cate_node_id) {
				url+='&cate_node_id='+filterForm.cate_node_id
			}
			console.log(url)
			window.open(url);
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},

	},
	// 过滤器
	filters: {
		session_ff(v,this_){
			var list=this_.SESSION_ARR;
			var fanhuizhi="";
			list.forEach(function(e, i) {
				if (e.code==v) {
					fanhuizhi=this_.lang=="cn"?e.name_cn:e.name;
				}
			});
			return fanhuizhi
		},
		teacher_f(v,this_){
			var list=this_.teacher;
			var fanhuizhi="";
			list.forEach(function(e, i) {
				if (e.teacher_id==v) {
					fanhuizhi=this_.lang=="cn"?e.name_cn:e.name;
				}
			});
			return fanhuizhi
		},

	}
}
</script>
<style scoped>
</style>
<style>
.demo-table-expand .el-form-item__label{
	padding: 0;
}
.demo-table-expand .el-form--inline .el-form-item{
	margin-right: 20px;
}
.router_link{
	display: inline;
	color: #ff0000;
}
.data_data{
	margin-right: 20px;
}
.filter-panel{
	width: calc(100% - 70px);
	float: left;
}

.el-descriptions th{
	width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/views/statistic/camp.vue